import { fetchWarehouseLocationList } from '#/api/system/warehouseLocation/fetchList';

export function mapWarehouseLocationRowsToSelectOptions(rows = []) {
  return rows.map((row) => ({
    value: row.id,
    label: row.code ? `${row.code} - ${row.name}` : (row.name || row.id),
  }));
}

/**
 * 依倉別拉儲位 select options（react-query；勿 saga）。
 */
export async function fetchWarehouseLocationSelectOptions(warehouseId) {
  if (!warehouseId) {
    return [];
  }

  const { data } = await fetchWarehouseLocationList({
    page: 1,
    pageSize: 200,
    keyword: '',
    sort: [],
    filters: { warehouseId },
  });

  return mapWarehouseLocationRowsToSelectOptions(data ?? []);
}
